// pages/AppCreation.js (design moderno)
import { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import StepNavigation from '../components/StepNavigation';
import Step1 from '../components/app-creation/Step1';
import Step2 from '../components/app-creation/Step2';
import Step3 from '../components/app-creation/Step3';
import Step4 from '../components/app-creation/Step4';
import Step5 from '../components/app-creation/Step5';
import Step6 from '../components/app-creation/Step6';
import { useApp } from '../context/AppContext';
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import PhoneVerificationModal from '../components/common/PhoneVerificationModal';

function AppCreation() {
  const { state, dispatch } = useApp();
  const { currentStep } = state;
  const [showPhoneModal, setShowPhoneModal] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        try {
          const userDoc = await getDoc(doc(db, 'users', user.uid));
          if (userDoc.exists()) {
            const userData = userDoc.data();
            if (!userData.phone) {
              setShowPhoneModal(true);
            }
          }
        } catch (error) {
          console.error('Erro ao verificar telefone do usuário:', error);
        }
      }
    });
    // Fetch pricing config
    const fetchPricingConfig = async () => {
      try {
        const docRef = doc(db, 'settings', 'pricing');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const pricing = docSnap.data();
          dispatch({ type: 'SET_PRICING_CONFIG', payload: pricing });
          // ✅ Garante que o preço base já é aplicado ao totalPrice imediatamente
          dispatch({ type: 'UPDATE_PRICE', payload: { base: pricing.base ?? 0 } });
        }
      } catch (error) {
        console.error('Erro ao buscar pricing:', error);
      }
    };
    fetchPricingConfig();

    return () => unsubscribe();
  }, [dispatch]);

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return <Step1 />;
      case 2:
        return <Step2 />;
      case 3:
        return <Step3 />;
      case 4:
        return <Step4 />;
      case 5:
        return <Step5 />;
      case 6:
        return <Step6 />;
      default:
        return <Step1 />;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="px-4 pt-4 sm:px-6 sm:pt-6 md:px-8 md:pt-8 max-w-7xl mx-auto w-full">
        <Navbar />
      </div>

      <div className="container mx-auto px-4 py-8 max-w-6xl">
        {/* Cabeçalho */}
        <div className="text-center mb-8 fade-in">
          {/*<h1 className="text-3xl font-bold text-gray-900 mb-2">Crie seu aplicativo</h1>
          <p className="text-gray-600">Siga os passos abaixo para criar seu aplicativo personalizado</p>*/}
        </div>

        {/* Navegação de steps moderna */}
        <StepNavigation />

        {/* Conteúdo do step atual */}
        <div className="p-6 md:p-8 slide-in">
          {renderStep()}
        </div>

        {/* Informação de progresso */}
        <div className="mt-6 text-center text-sm text-gray-500">
          Etapa {currentStep} de 6 • Seu aplicativo está {Math.round((currentStep / 6) * 100)}% completo
        </div>
      </div>

      {/* Modal de Telefone Obrigatório */}
      <PhoneVerificationModal 
        isOpen={showPhoneModal}
        onClose={() => setShowPhoneModal(false)}
        onSuccess={() => setShowPhoneModal(false)}
      />
    </div>
  );
}

export default AppCreation;